import React from 'react';
import Box from '@mui/system/Box';
import { useStacklineTheme } from '@stackline/ui';
import { useLocation } from 'src/utils/Hooks';
import { PresentationsBuilder } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationsBuilder';
import {
  PresentationsTab,
  PresentationsTabsPath
} from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/types';
import { PresentationsNavigationTabs } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationsNavigationTabs';
import PresentationFormProvider from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';
import BuilderHeader from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/components/BuilderHeader';

const PresentationsContainerLayout = () => {
  const theme = useStacklineTheme();
  const location = useLocation();

  const pathToTabMap: Record<string, PresentationsTab> = {
    [PresentationsTabsPath.type]: PresentationsTab.Type,
    [PresentationsTabsPath.selections]: PresentationsTab.Selections,
    [PresentationsTabsPath.brands]: PresentationsTab.Brands,
    [PresentationsTabsPath.confirmations]: PresentationsTab.Confirmation
  };

  return (
    <Box width="100%">
      <PresentationFormProvider>
        <BuilderHeader />
        <Box marginBottom={theme.spacing.lg}>
            <PresentationsNavigationTabs tab={pathToTabMap[location.pathname]} />
            <PresentationsBuilder />
        </Box>
      </PresentationFormProvider>
    </Box>
  );
};

export default PresentationsContainerLayout;
